import { findTokenAtPos } from '@greycat/lang';
var GreyCatHover = /** @class */ (function () {
    function GreyCatHover() {
    }
    GreyCatHover.prototype.doHover = function (doc, pos, gcr) {
        var hover = null;
        var token = findTokenAtPos(gcr.lexResult.tokens, { character: pos.character + 1, line: pos.line + 1 });
        if (token) {
            return {
                contents: {
                    kind: 'markdown',
                    language: 'greycat',
                    value: "(" + token.tokenType.tokenName + ") " + token.image,
                },
            };
        }
        return hover;
    };
    return GreyCatHover;
}());
export default GreyCatHover;
//# sourceMappingURL=gc-hover.js.map